module.exports = __webpack_public_path__ + "img/sn.d488be6f.svg";